var _rect, _line, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppVersion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 31,
    height: 46,
    rx: 8,
    ry: 8,
    stroke: "#F5A623",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 14,
    x2: 31,
    y2: 14,
    stroke: "#F5A623",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35, 36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.25 -2.39 L 11.25 2.39 L 8.08 2.63 L 6.32 5.69 L 7.69 8.55 L 3.55 10.94 L 1.77 8.31 L -1.77 8.31 L -3.55 10.94 L -7.69 8.55 L -6.32 5.69 L -8.08 2.63 L -11.25 2.39 L -11.25 -2.39 L -8.08 -2.63 L -6.32 -5.69 L -7.69 -8.55 L -3.55 -10.94 L -1.77 -8.31 L 1.77 -8.31 L 3.55 -10.94 L 7.69 -8.55 L 6.32 -5.69 L 8.08 -2.63 Z",
    stroke: "#B32638",
    strokeWidth: 2.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    stroke: "#B32638",
    strokeWidth: 2.6,
    fill: "#FFFFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 33 56 C 45 56 55 47 55 33",
    stroke: "#B32638",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 48 33 L 55 24 L 62 33",
    stroke: "#B32638",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppVersion);
export default __webpack_public_path__ + "static/media/app-version.70ba92780b62941195811b5c3f6801a3.svg";
export { ForwardRef as ReactComponent };